{
    "Accessibility menu": "Meniu Accesibilitate",
    "Close": "Închide",
    "Content adjustments": "Ajustări Conținut",
    "Navigation adjustments": "Ajustări Navigare",
    "Text Align": "Aliniere text",
    "Align Left": "Aliniere la stânga",
    "Align Center": "Aliniere la centru",
    "Align Right": "Aliniere la dreapta",
    "Adjust Font Size": "Ajustează Dimensiunea Fontului",
    "Highlight Title": "Evidențiază Titlul",
    "Highlight Links": "Evidențiază Link-urile",
    "Readable Font": "Font Lizibil",
    "Colour adjustments": "Ajustări Culoare",
    "Dark Contrast": "Contrast Întunecat",
    "Light Contrast": "Contrast Deschis",
    "High Contrast": "Contrast Ridicat",
    "High Saturation": "Saturație Ridicată",
    "Low Saturation": "Saturație Scăzută",
    "Monochrome": "Monocrom",
    "Tools": "Instrumente",
    "Reading Guide": "Ghid de Citire",
    "Big Cursor": "Cursor Mare",
    "Increase Font Size": "Mărește Dimensiunea Fontului",
    "Decrease Font Size": "Micșorează Dimensiunea Fontului",
    "Letter Spacing": "Spațiere Litere",
    "Line Height": "Înălțime Linie",
    "Font Weight": "Grosime Font",
    "Dyslexia Font": "Font pentru Dislexie",
    "Language": "Limbă",
    "Accessibility widget": "Deschide Meniul de Accesibilitate",
    "Accessibility Profiles": "Profiluri de Accesibilitate",
    "Cognitive Disability": "Dizabilitate Cognitivă",
    "Seizure Safe": "Sigur pentru Epilepsie",
    "Accessibility statement": "Declarație de Accesibilitate",
    "ADHD": "ADHD",
    "Low Vision": "Vedere slabă",
    "Pause Animations": "Oprește Animațiile",
    "Animation paused": "Animație întreruptă",
    "Reset all settings": "Resetează setările",
    "Shortcut:": "Scurtătură:",
    "Epilepsy Safe Mode": "Mod sigur pentru epilepsie",
    "Mute sounds": "Dezactivează sunetele",
    "Page read": "Citirea paginii",
    "Page read controls": "Comenzi de citire",
    "Pause": "Pauză",
    "Resume": "Reluare",
    "Stop": "Oprire",
    "Settings": "Setări",
    "Speed": "Viteză",
    "Voice": "Voce",
    "Close accessibility menu": "Închide meniul de accesibilitate",
    "Back to accessibility menu": "Înapoi la meniul de accesibilitate",
    "Search languages": "Caută limbi",
    "Selected language": "Limba selectată",
    "View accessibility statement (opens in new window)": "Vezi declarația de accesibilitate (se deschide într-o fereastră nouă)",
    "Visit CookieYes website (opens in new window)": "Vizitează site-ul CookieYes (se deschide într-o fereastră nouă)",
    "Reset all accessibility settings to default": "Resetează toate setările de accesibilitate"
}
